module.exports = __webpack_public_path__ + "static/media/20170806_18day_0785AT.886bede0.jpg";